import * as React from 'react';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';
import Constants from '../../globals/Constants';
import HelpLink from '../HelpLink/HelpLink';

export default ({reviewers, onManageReviewersClick, themeName}: ReviewersSummaryProps) => {
   const shareReviewModalStrings = Strings.labels.shareReviewModal;

   const getReviewersSummary = () => {
      const count = reviewers.length;
      const {noReviewersAdded, oneReviewerAdded, multipleReviewersAdded} = Strings.labels.shareReviewModal;
      if (count === 0) {
         return noReviewersAdded;
      }
      if (count === 1) {
         return oneReviewerAdded;
      }
      return multipleReviewersAdded.replace('{param0}', `${count}`);
   };

   return (
      <div className="reviewers-summary share-review-section">
         <div className="reviewers-summary-title">
            {shareReviewModalStrings.reviewers}
            <HelpLink href={Constants.siteLinks.help.reviewers} />
         </div>

         <div className="reviewers-summary-status">
            {getReviewersSummary()}
         </div>

         <ControlButton
            testId="manage-reviewers-button"
            themeName={themeName}
            buttonType={TscButtonType.secondary}
            label={shareReviewModalStrings.manageReviewers}
            isFullWidth={true}
            onClick={onManageReviewersClick}
         />
      </div>
   );
};

export interface ReviewersSummaryProps extends Themeable {
   reviewers: SimpleReviewerModel[];
   onManageReviewersClick(): void;
}
